export class DateRange {
  from: Date = null;
  to: Date = null;
}
